export const CHART = {
  blue: "#0047AB",
  orange: "#FF4F00",
  green: "#10B981",
  violet: "#8B5CF6",
  sky: "#0EA5E9",
  amber: "#F59E0B",
  slate: "#94A3B8",
  red: "#EF4444",
};

export const CHART_SEQ = [CHART.blue, CHART.orange, CHART.green, CHART.violet, CHART.sky, CHART.amber];

export const usd = (v) => `US$${Number(v).toLocaleString()}`;
export const num = (v) => Number(v).toLocaleString();
export const pct = (v) => `${v > 0 ? "+" : ""}${v}%`;
export const teu = (v) => `${(Number(v) / 1000).toFixed(0)}k TEU`;

// Dark custom tooltip used across every chart.
export function ChartTip({ active, payload, label, formatter, labelSuffix = "" }) {
  if (!active || !payload || !payload.length) return null;
  const fmt = formatter || ((v) => Number(v).toLocaleString());
  return (
    <div className="rounded-lg border border-slate-700 bg-slate-900 px-3.5 py-2.5 shadow-xl">
      {label !== undefined && (
        <div className="font-num text-[11px] uppercase tracking-wider text-slate-400 mb-1.5">
          {label}
          {labelSuffix}
        </div>
      )}
      <div className="space-y-1">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center gap-2.5">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: p.color || p.fill }} />
            <span className="text-xs text-slate-300">{p.name}</span>
            <span className="ml-auto font-num text-sm font-semibold text-white">{fmt(p.value, p.payload)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
